export default __webpack_public_path__ + "static/media/recording-active.e82847b8.svg";